/** Shared public links. Header stays short; footer adds legal pages. No About until a founder is named. */

export type PublicNavLink = {
  to: string;
  label: string;
};

export const PUBLIC_HEADER_LINKS: readonly PublicNavLink[] = [
  { to: '/#product', label: 'Product' },
  { to: '/pricing/', label: 'Pricing' },
  { to: '/changelog/', label: 'Changelog' },
];

export const PUBLIC_FOOTER_LINKS: readonly PublicNavLink[] = [
  ...PUBLIC_HEADER_LINKS,
  { to: '/privacy/', label: 'Privacy' },
  { to: '/terms_of_service/', label: 'Terms of Service' },
];
